var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTvFundraising = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Election-Campaign-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Election Campaign 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.23 0h-12A3.77 3.77 0 0 0 4.5 3.77v5.92a3.68 3.68 0 0 0 0.5 1.78 1 1 0 0 0 1.59 0.23s1.15 -1.15 2.31 -2.36a10.9 10.9 0 0 1 2.52 3.94 1 1 0 0 0 1 0.68H14v2a1 1 0 0 0 0.58 0.91A1.06 1.06 0 0 0 15 17a1 1 0 0 0 0.65 -0.24L18.88 14l1.35 0A3.77 3.77 0 0 0 24 10.19V3.77A3.77 3.77 0 0 0 20.23 0Zm-1.68 7.36 -3.19 3.33a0.51 0.51 0 0 1 -0.72 0l-3.2 -3.33a2.39 2.39 0 0 1 1.32 -4.05 2.34 2.34 0 0 1 2.07 0.69l0.17 0.17 0.17 -0.17a2.34 2.34 0 0 1 2.07 -0.67 2.39 2.39 0 0 1 1.31 4.05Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.9 19.77 -3.6 -7.63a1 1 0 0 0 -0.86 -0.57 1 1 0 0 0 -0.91 0.48l-0.35 0.6a10.36 10.36 0 0 1 -4.47 4l-1 0.49a2.91 2.91 0 0 0 1.25 5.55 3 3 0 0 0 1.25 -0.28l0.23 -0.11a4.85 4.85 0 0 0 2.23 1.59A1 1 0 0 0 7 24a1 1 0 0 0 0.33 -1.94 3 3 0 0 1 -1 -0.55 10.39 10.39 0 0 1 4.83 -0.43l0.68 0.1a1 1 0 0 0 1.05 -1.41Zm-7.63 0L4.45 18a12.32 12.32 0 0 0 3.81 -3.41L10.32 19a12.27 12.27 0 0 0 -5.05 0.77Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTvFundraising);
export default ForwardRef;